<template><div><h1>VUX V2.5.10 发布日志</h1>
<h2><a href="/zh-CN/components/calendar.html">Calendar</a></h2>
<ul><li>[feature] 支持 prop:placeholder</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] 值文字颜色受控于 @cell-value-color #1874</li>
</ul>
<h2><a href="/zh-CN/components/marquee.html">Marquee</a></h2>
<ul><li>[feature] 支持 prop:item-height #1885</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[feature] 值文字颜色受控于 @cell-value-color #1874</li>
</ul>
<h2><a href="/zh-CN/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[feature] 值文字颜色受控于 @cell-value-color #1874</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[fix] 修复 class 工具函数拼写错误 #1893</li>
</ul>
<h2><a href="/zh-CN/components/previewer.html">Previewer</a></h2>
<ul><li>[enhance] 支持 goTo 方法 #1888</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.10 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.10-242.vue?a303804a